<template>
  <div id="reservations">
    <div class="reservation-background">
      <location-down-messages/>
      <div id="reservation-selectors" v-if="bookingState=='beforeSearch' || bookingState=='pickingTime'">
        <pickers v-on:resetSelectedSuggestion="resetSelectedSuggestion" :closed="closed"></pickers>
        <div id="count-your-kids">Due to the nature of our seating style, please count everyone in your party including children and infants.</div>
        <search-button v-if="bookingState=='beforeSearch'" v-on:searchAvailability="searchAvailability"></search-button>
      </div>

      <div id="suggestions-loadscreen" v-if="bookingState=='pickingTime'">
        <suggested-times v-on:timeSelected="timeSelected"></suggested-times>
      </div>

      <div id="user-info-outer" v-if="bookingState=='enteringInfo'">
        <div id="search-info">
          <el-button
            id="resetSelectedSuggestionButton"
            @click="resetSelectedSuggestion">
            click here to search for another time
          </el-button>
          <div id="res-info-outer">
            <div id="res-info">
              <info-res></info-res>
            </div>
          </div>
        </div>
        <div id="user-info">
          <info-user></info-user>
          <agreements></agreements>
          <div id="book">
            <div id="update-disclaimer" v-if="res_token">You are updating your priority booking reservation. It will not be updated until "Complete Booking" is clicked!</div>
            <el-button
              id="book-button"
              :disabled="disableSearch"
              type="primary"
              @click='completeBooking'>
              {{ completeBookingText }}
            </el-button>
            <!-- <el-button @click="fillUserInfoFields">fill user info</el-button> -->
            <div id="book-disclaimer" v-if="false">
              By clicking "Complete Booking" you agree to
              the <a id="terms-of-use" @click="showTermsOfUse">Arigato Terms of Use and Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>


      <reservation-booked
        v-if="bookingState=='booked'"
        :bookingCompletedMessage="'Your online priority seating booking is complete.'">
      </reservation-booked>

      <reservation-error
        v-if="bookingState=='error'"
        error-message="Looks like something went wrong with the booking process.">
      </reservation-error>

      <reservation-error
        v-if="bookingState=='serverDown'"
        error-message="Online priority seating bookings are not available at this time.">
      </reservation-error>

      <div id="disclaimer" v-if="bookingState != 'booked'">
        <span id="disclaimer-header">Disclaimer:</span> Spots are not saved until booking is completed. rarely, selected time may become booked by another party before your booking is completed.
      </div>
    </div>


  </div>
</template>

<script>
//notes: using v-show for pickers section to keep info from refreshing

//<el-button @click="fillUserInfoFields">fill user info</el-button>

import moment from 'moment'
import axios from 'axios'
import { mapState } from 'vuex'
import { Loading } from 'element-ui'
import * as types from '@store/mutation-types'

import pickers from '@comp/pickers'
import suggestedTimes from '@comp/suggestedTimes'
import infoRes from '@comp/infoRes'
import infoUser from '@comp/infoUser'
import agreements from '@comp/agreements'
import reservationBooked from '@comp/reservationBooked'
import reservationError from '@comp/reservationError'
import searchButton from '@comp/buttonSearch'
import locationDownMessages from '@comp/locationDownMessages'

export default {
  name: "reservation",
  components: {
    pickers,
    suggestedTimes,
    infoRes,
    infoUser,
    agreements,
    reservationBooked,
    reservationError,
    searchButton,
    locationDownMessages
  },
  props: [ "lts", "fts", "loc", "closed", "res_token" ],
  data: function () {
    return {
      showSuggestions: false,
      loadingSuggestions: false,
      loadingSuggestionsEl: null,
      loadingBooking: false,
      bookingState: 'beforeSearch', //'serverDown', 'beforeSearch', 'pickingTime', 'enteringInfo' ,'booked', 'error'
    }
  },
  computed: {
    ...mapState({
      location: state => state.availability.location,
      date: state => state.availability.date,
      partySize: state => state.availability.partySize,
      time: state => state.availability.time,
      suggestionSelected: state => state.availability.suggestedTimes.selected,
      disableSearch: state => state.availability.disableSearch,
    }),
    serverRunning() {
      return ( this.fts && this.lts )
    },
    completeBookingText() {
      if ( this.loadingBooking ) {
        return 'Booking...'
      } else {
        return 'Complete Booking'
      }
    },
  },
  watch:{
    serverRunning() {
      if ( !this.serverRunning ) {
        this.bookingState = 'serverDown'
      }
    },
    loadingSuggestions() {
      var el = document.getElementById( 'suggestions-loadscreen' )
      if ( this.loadingSuggestions ) {
        if ( el ) {
          this.loadingSuggestionsEl = Loading.service({ target: el, text: 'loading...' })
          var el_mask = el.querySelector( '.el-loading-mask' )
          el_mask.style.zIndex = 999 //keep it below the reservation availability selectors
        }
      } else {
        if ( this.loadingSuggestionsEl ) {
          this.loadingSuggestionsEl.close()
        }
      }
    },
  },
  methods: {
    showTermsOfUse() {
      let response = axios.get('/terms_of_use.html')
        .then( response => {
          let termsOfUseText = response.data
          // this.$msgbox( { message: termsOfUseText, title: 'Terms of Use & Privacy Policy',
          //   confirmButtonText: 'OK', dangerouslyUseHTMLString: false
          // })
          this.$alert('<strong>This is <i>HTML</i> string</strong>', 'HTML String', {
          dangerouslyUseHTMLString: true
        });
        })

    },
    fillUserInfoFields() {
      this.$store.commit( 'userInfo/UPDATE_FIRST_NAME', "test1")
      this.$store.commit( 'userInfo/UPDATE_LAST_NAME', "test1")
      this.$store.commit( 'userInfo/UPDATE_PHONE', "3369262834")
      this.$store.commit( 'userInfo/UPDATE_EMAIL', "mack@mackstudio.net")
      this.$store.commit( 'userInfo/UPDATE_ACCEPT_POLICY', true )

    },
    resetSelectedSuggestion() {
      this.$store.commit( 'availability/CLEAR_SUGGESTED_TIMES')
      this.$store.commit( 'availability/SELECT_SUGGESTED_TIME', null )
      this.bookingState = 'beforeSearch'
    },
    timeSelected( val ) {
      this.$store.commit( 'availability/CLEAR_SUGGESTED_TIMES')
      this.$store.commit( 'availability/SELECT_SUGGESTED_TIME', val )
      this.bookingState = 'enteringInfo'
    },
    async searchAvailability() {
      this.loadingSuggestions = true

      await this.$store.dispatch( 'availability/getSuggestedTimes', {
        location: this.location,
        date: this.date,
        partySize: this.partySize,
        time: this.time,
        res_token: this.res_token
      } )

      this.loadingSuggestions = false
      let timeRequested = this.$store.state.availability.suggestedTimes.requested 
      if ( timeRequested == null ) {
        //show prior and after times if time requested is unavailable
        this.bookingState = 'pickingTime'
      } else {
        //otherwise, assume that's what they want and move to the entering info state
        this.timeSelected( timeRequested ) 
      }

      //add a copy of current url to history for back button
      history.pushState("", document.title, window.location )
      window.onpopstate = function(event) {
        if ( window.location.pathname.substring(0, 12) == "/reservation" ) {
          location.reload()
        }
      }
    },
    async completeBooking() {
      if ( !this.loadingBooking ) {
        let validationPassed = await this.$store.dispatch( 'userInfo/validate')

        if ( validationPassed ) {
          this.loadingBooking = true
          let bookedSuccess = await this.$store.dispatch( 'userInfo/completeBooking' )
          this.loadingBooking = false

          if ( bookedSuccess ) {
            this.bookingState = 'booked'
          } else {
            this.bookingState = 'error'
          }
        }
      } else {

      }
    },
  },
  beforeMount() {
    this.$store.commit( 'availability/UPDATE_LOCATION', this.loc )

    if ( this.fts && this.lts ) {
      this.$store.commit( 'availability/UPDATE_FIRST_TIMESLOT', this.fts )
      this.$store.commit( 'availability/UPDATE_LAST_TIMESLOT', this.lts )
    } else {
      this.bookingState = "serverDown"
    }
  },
  mounted() {
    this.$store.dispatch( 'availability/heartbeatTimer' )
  },
}

</script>

<style lang="scss" scoped>

.location {
  font-weight: bold;
}

.server-down {
}

#reservations {
  box-sizing:border-box;
  padding: 10px;
}

.reservation-background {
  box-sizing:border-box;
  width: 100%;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
}

#reservation-selectors {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
}

#res-info-outer {
  width: 100%;
}
#res-info {
  margin: 10px auto;
  padding: 10px 0;
  display: inline-block;
  text-align: left;
  border-top: 1px solid #999;
  border-bottom: 1px solid #999;
}

#suggestions-loadscreen {
  min-height: 80px;
  width: 100%;
}

#disclaimer {
  margin-top: 30px;
  font-size: 90%;
}

#disclaimer-header {
  font-weight: bold;
}

#resetSelectedSuggestionButton {
  margin-left: 10px;
  border-color: #a71313;
  color: #a71313;
  font-weight: bold;

  @media screen and (max-width: 768px) {
    width: 90%;
  }
}

#selected-time-label {
  font-weight: bold;
}

#user-info-outer {
 width: 100%;
}

#user-info {
  min-height: 80px;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
}

#book {
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  @media screen and (max-width: 768px) {
    margin-top: 8px;
  }
}

#book-disclaimer {
  margin-top: 10px;
}

#book-button {
  width: 70%;

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-top: 20px;
  }
}

#terms-of-use {
  color: #ad1313;
  cursor: pointer;
}

#update-disclaimer {
  color: #ad1313;
  font-weight: bold;
}

#count-your-kids {
  clear: left;
  float: left;
  width: 100%;
  text-align: center;
  @media screen and (max-width: 425px) {
    display: none;
  }
}

</style>
